import { createSlice } from "@reduxjs/toolkit";
import { decodeIdToken } from "../../shared/utils/decodeIdToken";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    accessToken: null,
    idToken: null,
    user: null,
    isInitializing: true,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, idToken } = action.payload;
      state.accessToken = accessToken;
      state.idToken = idToken;
      state.user = idToken ? decodeIdToken(idToken) : null;
      state.isInitializing = false;
    },
    clearCredentials: (state) => {
      state.accessToken = null;
      state.idToken = null;
      state.user = null;
      state.isInitializing = false;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export const userInfo = (state) => state.auth.user;
export const isAuthInitializing = (state) => state.auth.isInitializing;
export const accessToken = (state) => state.auth.accessToken;

export default authSlice.reducer;